<div id="head-nav" class="navbar navbar-default navbar-fixed-top cookiebar" *ngIf="!cookieMsgRead">
  <div class="container-fluid">
    <div class="navbar-header text-center full-width padding-sides-9">
      {{'COOKIES_MESSAGE' | translate}}
      <button type="button" class="btn btn-sm btn-default" [title]="'OK' | translate" (click)="dismissCookieMessage()">
        <i class="fas fa-check"></i>&nbsp;{{'OK' | translate}}
      </button>
    </div>
  </div>
</div>
<div id="cl-wrapper" class="login-container login-theme">
  <!-- <div class="middle-login"> -->
  <div class="login-form">
    <div class="block-flat">
      <div class="header">
        <h3 class="text-center">
          <img alt="" class="img-responsive logo-img">
        </h3>
      </div>
      <div *ngIf="!submitted && form">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-horizontal">
          <div class="content">
            <h3 class="title">{{'SIGN_UP' | translate}}</h3>

            <div class="alert alert-danger" *ngIf="formAllErrors.length > 0">
              <i class="fas fa-times-circle sign"></i>
              <strong>{{'ERROR'|translate}}:</strong> {{formAllErrors}}
            </div>

            <div class="panel panel-default">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn1"
                (click)="collPn1 = !collPn1">
                <h5 class="panel-title">
                  <i class="fas fa-building"></i>
                  <strong>{{'COMPANY_DATA'|translate}}</strong>
                  <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn1, 'fa-caret-up': !collPn1}"></i>
                </h5>
              </div>
              <div id="collPn1" class="panel-body no-horizontal-padding collapse in">

                <div class="form-group" *ngIf="serviceProviders && serviceProviders.length > 1">
                  <div class="col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>{{'PARTNER'|translate}}</mat-label>
                      <mat-select formControlName="OwnerID">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let serviceProvider of serviceProviders" [value]="serviceProvider.ID">{{
                          serviceProvider.Name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="formErrors.OwnerID" class="font75per"> {{ formErrors.OwnerID }}</mat-error>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>{{'COMPANY_NAME'|translate}}</mat-label>
                      <input type="text" matInput
                        formControlName="CompanyName">
                    </mat-form-field>
                    <mat-error *ngIf="formErrors.CompanyName" class="font75per"> {{ formErrors.CompanyName }}
                    </mat-error>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>{{'COUNTRY'|translate}}</mat-label>
                      <mat-select formControlName="CompanyCountry">
                        <mat-option *ngFor="let country of countries" [value]="country.Code">{{ country.Name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="formErrors.CompanyCountry" class="font75per"> {{ formErrors.CompanyCountry }}
                    </mat-error>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>{{'TAX_NUMBER'|translate}}</mat-label>
                      <input type="text" matInput
                        formControlName="CompanyTaxNumber">
                    </mat-form-field>
                    <mat-error *ngIf="formErrors.CompanyTaxNumber" class="font75per"> {{ formErrors.CompanyTaxNumber
                      }}</mat-error>
                  </div>
                </div>

              </div>
            </div>

            <div class="panel panel-default">
              <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPn2"
                (click)="collPn2 = !collPn2">
                <h5 class="panel-title">
                  <i class="fas fa-user"></i>
                  <strong>{{'USER_DATA'|translate}}</strong>
                  <i class="collapse-icon fas" [ngClass]="{'fa-caret-down': collPn2, 'fa-caret-up': !collPn2}"></i>
                </h5>
              </div>
              <div id="collPn2" class="panel-body no-horizontal-padding collapse in">

                <div class="form-group">
                  <div class="col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>{{'USER_NAME'|translate}}</mat-label>
                      <input type="text" matInput formControlName="UserName">
                    </mat-form-field>
                    <mat-error *ngIf="formErrors.UserName" class="font75per"> {{ formErrors.UserName }}</mat-error>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>{{'EMAIL'|translate}}</mat-label>
                      <input type="text" matInput formControlName="UserEmail">
                    </mat-form-field>
                    <mat-error *ngIf="formErrors.UserEmail" class="font75per"> {{ formErrors.UserEmail }}</mat-error>
                  </div>
                </div>

                <div class="form-group">
                  <div class="col-sm-12">
                    <mat-form-field class="full-width">
                      <mat-label>{{'LANGUAGE'|translate}}</mat-label>
                      <mat-select formControlName="UserLocale">
                        <mat-option *ngFor="let language of languages" [value]="language.Code">{{language.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="formErrors.UserLocale" class="font75per"> {{ formErrors.UserLocale }}</mat-error>
                  </div>
                </div>

              </div>
            </div>

            <!-- <div class="form-group">
              <div class="col-sm-12">
                <div nbRecaptcha key="6LeGEGQUAAAAAFmKn8GIKszhKjdASxFZzljogED6" formControlName="Captcha"></div>
                <mat-error *ngIf="formErrors.Captcha" class="font75per"> {{ formErrors.Captcha }}</mat-error>
              </div>
            </div> -->

          </div>
          <div class="foot">
            <button type="button" class="btn pull-left no-margin-left" title="{{'BUTTON.BACK' | translate}}"
              [routerLink]="['/login']">
              <i class="fas fa-arrow-left"></i>&nbsp;{{'BUTTON.BACK' | translate}}
            </button>

            <button type="submit" class="btn btn-primary" title="{{'REGISTER' | translate}}" [disabled]="form.invalid">
              <i class="fas fa-edit"></i>&nbsp;{{'REGISTER' | translate}}
            </button>
          </div>
        </form>
      </div>

      <div *ngIf="submitted">
        <div class="content">
          <h3 class="title">{{'SIGN_UP' | translate}}</h3>
          <div>{{'REGISTRATION_SUCCESS' | translate}}</div>
        </div>
        <div class="foot">
          <button type="button" class="btn" title="{{'BUTTON.BACK' | translate}}" [routerLink]="['/login']">
            <i class="fas fa-arrow-left"></i>&nbsp;{{'BUTTON.BACK' | translate}}
          </button>
        </div>
      </div>
    </div>
    <div class="text-center out-links">
      <a [href]="loginFooterUrl" target="_blank" [innerHtml]="loginFooterText"></a>
    </div>
  </div>
</div>